/* eslint-disable no-undef */
// noinspection JSUnusedGlobalSymbols
import Base from './base.js';
import Gikam from '../core/gikam-core.js';
import jQuery from 'jquery';

let defaultOptions = {
    url: void 0,
    taskId: void 0,
    data: void 0,
    columns: void 0,
    appendFields: [],
    requestParam: void 0,
    initData: void 0,
    success: [],
    fail: [],
    def: void 0
};

export default class Workflow extends Base {

    constructor(props) {
        super();
        this.initialize(props, defaultOptions);
        this.options.def = jQuery.Deferred();
    }

    validateUser(userId, password) {
        return Gikam.getText(Gikam.printf(Gikam.IFM_CONTEXT + '/open/core/module/mdm/user-passwords/userId/{userId}/password/{password}/action/validate-user', {
            userId : userId,
            password : Gikam.md5(password)
        }))
    }

    submit(param) {
        Gikam.extend(true, this.options, param, {
            title: Gikam.propI18N('GIKAM.WORKFLOW.BUTTON.SUBMIT'),
            opinionTitle: Gikam.propI18N('GIKAM.WORKFLOW.SUBMIT.OPINION.TITLE'),
            defaultOpinion: Gikam.propI18N('GIKAM.WORKFLOW.SUBMIT.OPINION.DEFAULT'),
            fileUpload: false,
            url: param.pageObject.baseUrl + '/action/start-process',
            columns: param.pageObject.workflow.columns
        });
        this.openOpinionModal();
        return this.options.def;
    }

    pass(param) {
        Gikam.extend(true, this.options, param, {
            title: Gikam.propI18N('GIKAM.WORKFLOW.BUTTON.PASS'),
            opinionTitle: Gikam.propI18N('GIKAM.WORKFLOW.PASS.OPINION.TITLE'),
            defaultOpinion: Gikam.propI18N('GIKAM.WORKFLOW.PASS.OPINION.DEFAULT'),
            fileUpload: true,
            url: param.pageObject.baseUrl + '/action/complete-task',
            columns: param.pageObject.workflow.columns
        });
        this.openOpinionModal();
        return this.options.def;
    }

    review(param) {
        let _this = this;

        Gikam.create('modal', {
            title: 'GIKAM.WORKFLOW.REVIEW.MODAL.CHOOSE_USER',
            url: IFM_CONTEXT + '/secure/core/module/mdm/users/page/choose-list?targetType=audit',
            onAfterClose: function (rows) {
                if (rows) {
                    let chooseData = {
                        "auditor": rows.map(function (item) {
                            return item.id
                        })
                    };

                    Gikam.extend(true, _this.options, param, {
                        title: Gikam.propI18N('GIKAM.WORKFLOW.BUTTON.REVIEW'),
                        opinionTitle: Gikam.propI18N('GIKAM.WORKFLOW.REVIEW.OPINION.TITLE'),
                        defaultOpinion: Gikam.propI18N('GIKAM.WORKFLOW.REVIEW.OPINION.DEFAULT'),
                        fileUpload: true,
                        requestParam: chooseData,
                        url: param.pageObject.baseUrl + '/action/review-task',
                        columns: param.pageObject.workflow.columns
                    });

                    _this.openOpinionModal();
                }
            }
        });
        return _this.options.def;
    }

    delegate(param) {
        const _this = this;

        Gikam.create('modal', {
            title: 'GIKAM.WORKFLOW.DELEGATE.MODAL.CHOOSE_USER',
            url: IFM_CONTEXT + '/secure/core/module/mdm/users/page/choose-list?targetType=audit',
            onAfterClose: function (rows) {
                if (rows) {
                    const chooseData = {
                        "auditor": rows.map(function (item) {
                            return item.id
                        })
                    };

                    Gikam.extend(true, _this.options, param, {
                        title: Gikam.propI18N('GIKAM.WORKFLOW.BUTTON.DELEGATE'),
                        opinionTitle: Gikam.propI18N('GIKAM.WORKFLOW.DELEGATE.OPINION.TITLE'),
                        defaultOpinion: Gikam.propI18N('GIKAM.WORKFLOW.DELEGATE.OPINION.DEFAULT'),
                        fileUpload: true,
                        requestParam: chooseData,
                        url: param.pageObject.baseUrl + '/action/delegate-task',
                        columns: param.pageObject.workflow.columns
                    });

                    _this.openOpinionModal();
                }
            }
        });
        return _this.options.def;
    }

    undo(param) {
        Gikam.extend(true, this.options, param, {
            title: Gikam.propI18N('GIKAM.BPMN.COMMENT.UNDO'),
            opinionTitle: Gikam.propI18N('GIKAM.WORKFLOW.UNDO.OPINION.TITLE'),
            defaultOpinion: Gikam.propI18N('GIKAM.WORKFLOW.UNDO.OPINION.DEFAULT'),
            fileUpload: false,
            url: param.pageObject.baseUrl + '/action/undo',
            columns: param.pageObject.workflow.columns
        });
        this.openOpinionModal();
        return this.options.def;
    }

    countersign(param) {
        let _this = this;

        Gikam.create('modal', {
            title: 'GIKAM.WORKFLOW.COUNTERSIGN.MODAL.CHOOSE_USER',
            url: IFM_CONTEXT + '/secure/core/module/mdm/users/page/choose-list?targetType=audit',
            onAfterClose: function (rows) {
                if (rows) {
                    let chooseData = {
                        "auditor": rows.map(function (item) {
                            return item.id
                        })
                    };

                    Gikam.extend(true, _this.options, param, {
                        title: Gikam.propI18N('GIKAM.WORKFLOW.BUTTON.COUNTERSIGN'),
                        opinionTitle: Gikam.propI18N('GIKAM.WORKFLOW.COUNTERSIGN.OPINION.TITLE'),
                        defaultOpinion: Gikam.propI18N('GIKAM.WORKFLOW.COUNTERSIGN.OPINION.DEFAULT'),
                        fileUpload: true,
                        requestParam: chooseData,
                        url: param.pageObject.baseUrl + '/action/countersign-task',
                        columns: param.pageObject.workflow.columns
                    });

                    _this.openOpinionModal();
                }
            }
        });
        return _this.options.def;
    }

    reject(param) {
        if (Gikam.isEmpty(param.data)) {
            Gikam.alert('GIKAM.TIP.CHOOSE_AT_LEAST_ONE_ITEM');
            return;
        }
        let _this = this;
        let bpmn_currentStatusCode = Gikam.getRequestParam(workspace.activeUrl).bpmn_currentStatusCode;
        let p = { bpmn_table: param.pageObject.workflow.dbTable };
        if (bpmn_currentStatusCode) {
            param.bpmn_currentStatusCode = bpmn_currentStatusCode;
        }
        let json = Gikam.getJsonWrapper(p, ['', param.data.map(item => {
            return {
                id: item.id
            }
        })]);
        Gikam.post(IFM_CONTEXT + '/secure/core/module/sys/bpmn-exts/options/rejectable-tasks', json).done(function (nodes) {

            _this.options.requestParam = Gikam.extend(_this.options.requestParam, {
                reverse: true
            });
            Gikam.extend(true, _this.options, param, {
                title: Gikam.propI18N('GIKAM.WORKFLOW.BUTTON.REJECT'),
                opinionTitle: Gikam.propI18N('GIKAM.WORKFLOW.REJECT.OPINION.TITLE'),
                defaultOpinion: Gikam.propI18N('GIKAM.WORKFLOW.REJECT.OPINION.DEFAULT'),
                fileUpload: false,
                url: param.pageObject.baseUrl + '/action/reject-task',
                columns: param.pageObject.workflow.columns,
                appendFields: [{
                    title: Gikam.propI18N('GIKAM.WORKFLOW.REJECT.REJECT_TO_TITLE'),
                    type: 'select',
                    field: 'bpmn_targetStatusCode',
                    firstBlank: false,
                    validators: ['notEmpty'],
                    value: nodes[0].statusCode,
                    items: nodes.map(function (item) {
                        return {
                            value: item.statusCode,
                            text: item.taskName
                        }
                    })
                }]
            });
            _this.openOpinionModal();
        });

        return this.options.def;
    }

    openOpinionModal() {
        let _this = this;

        if (Gikam.isEmpty(this.options.data)) {
            Gikam.alert('GIKAM.TIP.CHOOSE_AT_LEAST_ONE_ITEM');
            return;
        }
        let modal = Gikam.create('modal', {
            title: this.options.title,
            width: 500,
            height: 320,
            onAfterClose: function (data) {
                if (!data) {
                    return;
                }
                _this.options.opinionObject = data;
                delete _this.options.opinionModal;
                _this.submitData();
            }
        });

        Gikam.extend(this.options, {
            opinionModal: modal
        });

        const params = this.options.data.map(item => {
            return {
                id: item.id
            }
        })
        //是不是需要校验用户名和密码
        Gikam.post(this.options.pageObject.baseUrl + '/action/check-auth-required', Gikam.getJsonWrapper('',['', params])).done( r => {
            if (this.options.data.length === 1 && this.options.fileUpload) {
                this.getTaskId().done(function () {
                    _this.createOpinionPage(r);
                });
            } else {
                _this.createOpinionPage(r);
            }
        })

    }

    createOpinionPage(validateUser) {
        const getfields = () => {
            let fields = this.options.appendFields.concat([{
                title: this.options.opinionTitle,
                field: 'bpmn_comment',
                type: 'textarea',
                height: 100,
                value: this.options.defaultOpinion,
                rows: 5
            }]);

            if (validateUser) {
                fields = fields.concat([
                    {
                        title : '用户名',
                        field : 'userId',
                        type : 'text',
                        validators : [ 'notEmpty' ]
                    }, {
                        title : '密码',
                        field : 'password',
                        type : 'password',
                        validators : [ 'notEmpty' ]
                    }
                ])
            }
            return fields;
        }

        let formId = 'workflow-opinion-form-' + Date.now(),
            _this = this,
            defaultButtons = [{
                type: 'button',
                text: 'GIKAM.BUTTON.CONFIRM',
                class: 'blue',
                onClick: function () {
                    if (Gikam.getComp(formId).validate()) {
                        const data = Gikam.getComp(formId).getData();
                        if (validateUser) {
                            _this.validateUser(data.userId, data.password).done(function(r) {
                                if (r === '1') {
                                    _this.options.opinionModal.close(data);
                                } else {
                                    Gikam.alert('GIKAM.SECURITY.LOGIN.INCORRECT_USER_OR_PASSWORD');
                                }
                            });
                            return;
                        }
                        _this.options.opinionModal.close(data);
                    }
                }
            }, {
                type: 'button',
                text: 'GIKAM.BUTTON.CANCEL',
                onClick: function () {
                    _this.options.opinionModal.close();
                }
            }],

            buttons = defaultButtons,

            layout = Gikam.create('layout', {
                renderTo: this.options.opinionModal.window.$dom,
                center: {
                    items: [{
                        type: 'btnToolbar',
                        items: buttons
                    }, {
                        type: 'form',
                        columns: 1,
                        id: formId,
                        style: {
                            padding: '0 10px'
                        },
                        fields: getfields()
                    }]
                }
            });

        this.options.$fileContainer = this.createFileContainer(layout);

        if (this.options.taskId) {
            this.getFiles().done((files) => {
                if (files) {
                    _this.refreshFileList([JSON.parse(files)]);
                }
            });
        }
    }

    createFileContainer(layout) {
        let fileContainerTpl = '<div class="workflow-upload-result-container">' +
            '<div class="inner-container">' +
            '<div class="title">' + Gikam.propI18N('GIKAM.FILE.ATTACHMENT') + '：</div>' +
            '</div>' +
            '</div>';
        return jQuery(fileContainerTpl).appendTo(layout.options.center.$dom).hide();
    }

    refreshFileList(files) {
        if (Gikam.isEmpty(files)) {
            return;
        }
        let itemTpl = '<a href="javascript:;" onclick="Gikam.printFile({id}, true, null, false, true)">{name}</a>';
        let itemHtml = '';
        Gikam.each(files, function () {
            itemHtml += Gikam.printf(itemTpl, this);
        });
        this.options.$fileContainer.children('.inner-container').children('a').remove().end().append(itemHtml);
        this.options.$fileContainer.show();
    }

    getFiles() {
        return Gikam.getText(Gikam.printf(IFM_CONTEXT + '/core/module/item/files/filter-target/{targetId}', {
            targetId: 'ACT_COMMENT_[{loginUserId}]$' + this.options.taskId
        }));
    }

    getTaskId() {
        return Gikam.getJson(this.options.pageObject.baseUrl + `/${this.options.data[0].id}/info/status`);
    }

    uploadFile() {
        let _this = this;
        _this.getFiles().done(function (r) {

            if (r) {
                Gikam.alert('GIKAM.FILE.TIP.UPLOAD_ONE_ONLY');
                return;
            }

            Gikam.create('simpleUploader', {
                multiple: false,
                onBeforeUpload: function () {
                    this.setOptions({
                        dbTable: 'ACT_COMMENT_[{loginUserId}]',
                        bizId: _this.options.taskId
                    });
                },
                onAfterClose: function () {
                    _this.getFiles().done(function (files) {
                        files && _this.refreshFileList([JSON.parse(files)]);
                    });
                }
            });
        });
    }

    submitData() {
        workspace.window.showMask();
        let _this = this;
        Gikam.put(this.options.url, Gikam.getJsonWrapper(Gikam.extend(true, {}, this.options.requestParam, this.options.opinionObject), ['', this.options.data.map(item => {
            return {
                id: item.id
            };
        })])).done(() => {
            _this.options.def.resolve();
        }).always(() => {
            workspace.window.closeMask();
        });
    }

}